import React, { useRef,useState,useEffect } from 'react';
import { Helmet } from "react-helmet";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import RbCarousel from "react-bootstrap-carousel";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";


function WelcomeIw({match}) {
    let history = useHistory();
    const slide = useRef(null);
    const [loader, setLoader] = useState("true");
    const [slide1, SetSlide1] = useState("");
    const [slide2, SetSlide2] = useState("");
    const [slide3, SetSlide3] = useState("");
    const timerComponents = [];
    const [slide1Indcator, SetSlide1Indcator] = useState(<li key="si1" data-target="#carouselExampleControls" data-slide-to="0" className="active"></li>);
    const [slide2Indcator, SetSlide2Indcator] = useState(<li data-target="#carouselExampleControls" data-slide-to="1"></li>);
    const [skip, SetSkip] = useState("");
    // console.log(match.params);
    function goTo(params){
        console.log(params);
        slide.current.goToSlide(params);
    }

    useEffect(() => {
        setOrder();
        const interval = setInterval(() => {
			let timeLt = timeLeftToIW();
			// console.log(timeLt);
			setTimeLeft(timeLt);
		}, 1000);
		return () => {clearInterval(interval)};
	}, []);

    const timeLeftToIW = () => {
		let wet = localStorage.getItem("iwtime");
		const difference = +new Date(wet) - +new Date();
		let timeLeft = {};
		if (difference > 0) {
			timeLeft = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) %24 ),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				// seconds: Math.floor((difference / 1000) % 60),
			};
		} else {
			return {'no':1};
		}
		return timeLeft;
	};
    const [timeLeft, setTimeLeft] = useState(timeLeftToIW());

    let i =10000;
    Object.keys(timeLeft).forEach((interval) => {
		if(interval == 'no'){
			timerComponents.push("");
			return;
		}
		if (!timeLeft[interval] && timeLeft[interval] != 0) {
		  return;
		}
        let a = timeLeft[interval];
        if(interval == 'days'){
			timerComponents.push(
                <a key={i}>
					{a}{" Days : "}
				</a>
            );
		}
        if(interval == 'hours'){
			timerComponents.push(
                <a key={i}>
                    {a}{" hours : "}
                </a>
            );
		}
        if(interval == 'minutes'){
			timerComponents.push(
                <a key={i}>
                    {a}{" mins"}
                </a>
            );
		}
        // if(interval == 'seconds'){
		// 	timerComponents.push(
        //         <a key={i}>
        //             {a}{" secs"}
        //         </a>
        //     );
		// }
		i++;
	});

    const setOrder = async () => {
        setLoader("true");
        console.log(match.params);
	    if(localStorage.getItem("noSk") === "0"){
            setLoader("false");
            SetSkip(<a className='skip-btn' onClick={() => enterBKB() }>Skip</a>);
        }else{
            setTimeout(() => {
                setLoader("false");
            }, 3400);
        }
        // if(match.params.type === "skip"){
        //     console.log(match.params);
        //     setLoader("false");
        // }
        
        let kdName = localStorage.getItem("kdname");
        console.log(kdName !== "");
        if(kdName != ""){
            SetSlide1(
                <div key="s1" className="carousel-content">
                    You are selected as Rising Distributor of <b className='bolder'>{kdName} region</b>. You can help your kingdom to win battle with your power.
                    <div className='mgt2'>
                    <b className='bolder'>Benefits:</b>
                    </div>
                    Gain <b className='bolder'>5x points</b> on Battle of region day.
                </div>
            );
            SetSlide2(
                <div key="s1" className="carousel-content">
                    Top 3 Rising Distributors are invited to Mumbai for our Flagship Event.
                    <div className='bolder'>"Business ka Baadshah"</div>
                </div>
            );
        } else {
            SetSlide1(
                <div key="s1" className="carousel-content">
                    You are selected as Rising Distributor.
                </div>
            );
            SetSlide2(
                <div key="s1" className="carousel-content">
                    Top 3 Rising Distributors are invited to Mumbai for our Flagship Event.
                    <div className='bolder'>"Business ka Badshah"</div>
                </div>
            );
        }
    }

    function enterBKB(){
        localStorage.setItem("updateOnB", "1");
        setLoader("impact_warrior")
    }

    
    // }, 3);

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/welcome-iw.css'}]
	}/>

{ loader === "true" && (
    <div className="row no-gutters">
        <div className="bg-grey application">
            <div className='opening-gif'>
            {/* <img alt="" src={require("./../images/animation/1.gif").default} className="img-fluid" /> */}

            </div>
        </div>
        <div className="bg"></div>
    </div>
)
}
{ loader === "false" && (
    <div className="row no-gutters">
      <div className="bg-grey application">
        <div className="container-fluid px-0">
            {/* <div id="carouselExampleControls" className="carousel slide" data-ride="carousel"> */}
            <div id="carouselExampleControls" className="carousel slide" data-touch="true" data-ride="carousel" data-interval="false">
                <ol className="carousel-indicators">
                    <li key="si1" data-target="#carouselExampleControls" data-slide-to="0" className="active"></li>
                    <li key="si2" data-target="#carouselExampleControls" data-slide-to="1"></li>
                    <li key="si3" data-target="#carouselExampleControls" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner" role="listbox">
                    {/* 1st slide */}
                    <div key="s1" className="carousel-item active bkb" >
                        <div className="d-flex align-items-center justify-content-center min-vh-100" style={{backgroundImage:`url(${require("../images/Impact_player_screen/Onboarding_screen/Screen1.gif").default})`, backgroundSize: "100% 100%"}}>
                            {slide1}
                            <div className="carousel-button-footer">
                                {skip}
                                <img src={require("./../images/Impact_player_screen/home_screen/next_icon.png").default} alt="slider bkb" className="img-fluid next-btn" data-target="#carouselExampleControls" data-slide-to="1"/>
                            </div>
                        </div>
                    </div>

                    {/* 2nd slide */}
                    <div className="carousel-item bkb">
                        <div className="d-flex align-items-center justify-content-center min-vh-100"  style={{backgroundImage:`url(${require("../images/Impact_player_screen/Onboarding_screen/Screen2.png").default})`, backgroundSize: "100% 100%"}}>
                            {slide2}
                            <div className="carousel-button-footer">
                                {skip}
                                <img src={require("./../images/Impact_player_screen/home_screen/next_icon.png").default} alt="slider bkb" className="img-fluid next-btn" data-target="#carouselExampleControls" data-slide-to="2"/>
                            </div>
                        </div>
                    </div>
                    
                    {/* 3rd slide */}
                    <div className="carousel-item bkb">
                        <div className="d-flex align-items-center justify-content-center min-vh-100" style={{backgroundImage:`url(${require("../images/Impact_player_screen/Onboarding_screen/Screen3.gif").default})`, backgroundSize: "100% 100%"}}>
                            <div key="s3" className="carousel-content">
                                <b className='bolder'>Win 2x points on a daily basis</b> to boost up your score. Until the timer ends.
                                <div className='timer-box'>
                                    {timerComponents}
                                </div>
                            </div>
                            <div className="carousel-button-footer">
                                {skip}
                                <img src={require("./../images/Impact_player_screen/home_screen/EnterBKB.png").default} alt="slider bkb" className="img-fluid enter-bkb" data-target="#carouselExampleControls" onClick={() => enterBKB()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div className="bg"></div>
    </div>

)
}
{ loader === "impact_warrior" && (
    <Redirect to='/iw-home'  />
)
}   
</>
    );
}

export default WelcomeIw;
